import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKarpenterLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Type=karpenter, Color=Black",
		children: /* @__PURE__ */ _jsx("path", {
			id: "white_square_logo",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.0328 4C14.9572 4 17.3279 6.39407 17.3279 9.3473L17.3279 16.9074L19.8197 16.9074C21.0238 16.9074 22 17.8932 22 19.1092V21H21.7132C21.0207 21 20.4556 20.44 20.4426 19.7407V19.4251L20.4425 19.4095C20.4342 18.8956 20.0191 18.4815 19.5082 18.4815H7.04918C4.81288 18.4815 3 16.6507 3 14.3924L3 9.3473C3 6.39407 5.37069 4 8.29508 4H12.0328ZM11.7213 5.57407H8.60656L8.5396 5.57462C6.33418 5.61073 4.55738 7.42741 4.55738 9.66318V14.391L4.55771 14.4326C4.57972 15.8032 5.68676 16.9074 7.04918 16.9074H13.2787C14.6549 16.9074 15.7705 15.7808 15.7705 14.391V9.66318L15.7699 9.59556C15.7342 7.3684 13.9352 5.57407 11.7213 5.57407ZM8.61902 8.09259C8.9741 8.09259 9.25443 8.38537 9.25443 8.7537V10.6709L11.413 8.42315C11.6933 8.1587 12.0764 8.13981 12.3474 8.39481V8.40426C12.609 8.64981 12.5903 9.05593 12.3007 9.32037L10.7028 10.9826L12.5623 13.6648C12.7866 13.9954 12.7211 14.4109 12.4221 14.6093C12.0951 14.7981 11.7213 14.6943 11.497 14.3637L9.82443 11.8893L9.25443 12.4937V14.0426C9.25443 14.4204 8.9741 14.7037 8.61902 14.7037C8.26393 14.7037 7.98361 14.4204 7.98361 14.0426V8.7537C7.98361 8.38537 8.26393 8.09259 8.61902 8.09259Z",
			fill: "currentColor"
		})
	})
});
export default SvgKarpenterLogo;
